// extracted by mini-css-extract-plugin
module.exports = {"Subscribe":"SubsrcibeEu_Subscribe__qrw_B"};